import * as React from 'react';

type TBtnRef = HTMLElement | null;

/** хук проверяет находится ли элемент выше края экрана пользователя */
export const useButtonSticky = (ref: TBtnRef): boolean => {
  const [isBtnSticky, setBtnSticky] = React.useState<boolean>(false);
  const stickyContainer = ref?.getBoundingClientRect();

  React.useEffect(() => {
    const screenHeight = window.innerHeight;

    if (stickyContainer && stickyContainer?.bottom < screenHeight) {
      setBtnSticky(true);
    } else {
      setBtnSticky(false);
    }
  }, [ref]);

  return isBtnSticky;
};
